import { Component, Inject, LOCALE_ID } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PosterListComponent } from 'src/app/shared/components/poster-list/poster-list.component';
import { TryAndBookComponent } from 'src/app/shared/components/try-and-book/try-and-book.component';
import { NavigationService } from 'src/app/core/services/navigation/navigation.service';
import { MetaTagsService } from 'projects/qo-commons/src/services/meta-tags/meta-tags.service';
import { CustomerStory } from 'src/app/shared/components/customer-story/customer-story.data';
import { CustomerStoryComponent } from 'src/app/shared/components/customer-story/customer-story.component';

@Component({
    selector: 'app-federation-cyclisme',
    imports: [CommonModule, RouterModule, TryAndBookComponent, PosterListComponent, CustomerStoryComponent],
    templateUrl: './federation-cyclisme.component.html'
})
export class FederationCyclismeComponent {
  NavigationService = NavigationService;

  assetsPath = "assets/images/success-stories/federation-cyclisme/";
  
  customerStory: CustomerStory = {
    webp_photo_url: this.assetsPath + 'nicolas-andre-directeur-des-evenements.webp',
    photo_url: this.assetsPath + 'nicolas-andre-directeur-des-evenements.jpg',
    description: $localize`Avec Qoezion, nous fédérons notre communauté de bénévoles et la mobilisons pour nos événements internationaux nationaux et régionaux.`,
    logo_url: this.assetsPath + 'ff-cyclisme.svg',
    dark_logo_url: this.assetsPath + 'ff-cyclisme.svg',
    customer_name: "Nicolas André",
    customer_role: $localize`Directeur des événements`,
    types: []
  }

  constructor(private metaTagsService: MetaTagsService, @Inject(LOCALE_ID) public locale: string) {}

  ngAfterViewChecked() {
      this.metaTagsService.setSeoSettings({
          title: $localize`Structurer, fédérer et animer une communauté de bénévoles à l'échelle d'une fédération sportive`,
          description: $localize`Avec une approche progressive, la FFC a utilisé Qoezion pour identifier les bénévoles qui se sont engagés sur différents événements, formant ainsi une communauté dynamique qui grandit au fur et à mesure que de nouveaux événements sont organisés par la fédération et ses membres.`,
          imageUrl: `assets/images/success-stories/quickoff-customers.${this.locale}.jpg`
      });
  }
}
